/*
  Tohfa by Sonia — reveal on scroll.

  The prototype fades sections up as they enter the viewport (.reveal → .reveal.in).
  IntersectionObserver, one-shot per element. Honours prefers-reduced-motion by
  revealing everything immediately, and reveals everything if the API is missing,
  so content is never trapped at opacity 0.
*/
(function () {
  var nodes = document.querySelectorAll('.reveal');
  if (!nodes.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('in');
  }

  if (reduced || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);
})();
